import { lazyVue } from "@/utils";
export default [
    {
        path: "/",
        redirect: "/home"
    },
    {
        path: '/home',
        name: 'home',
        title: '福龄生活',
        component: lazyVue('home/index'),
        meta: {
            title: '福龄生活',
            name: '福龄生活',
            showBar: true,
            isKeepAlive: true,
        }
    },
    {
        path: '/homeAddress',
        name: 'homeAddress',
        title: '选择服务地址',
        component: lazyVue('home/address'),
        meta: {
            title: '选择服务地址',
            name: '选择服务地址',
            isKeepAlive: true,
        }
    },
    {
        path: '/homeAddress2',
        name: 'homeAddress2',
        title: '选择服务地址',
        component: lazyVue('home/address2'),
        meta: {
            title: '选择服务地址',
            name: '选择服务地址',
            isKeepAlive: true,
        }
    },
    {
        path: '/pageH5',
        name: 'pageH5',
        title: '福龄生活',
        component: lazyVue('pageH5/index'),
        meta: {
            title: '福龄生活',
            name: '福龄生活',
            isKeepAlive: true,
        }
    },
    {
        path: '/diy_page/:id',
        name: 'diy_page',
        title: '福龄生活',
        component: lazyVue('pageH5/index'),
        meta: {
            title: '福龄生活',
            name: '福龄生活',
            isKeepAlive: true,
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/home/index.js